/**
 * Global storage for blob URLs and their corresponding File objects
 * Used by RichText components to store uploaded images temporarily
 * Organized by field name to allow selective cleanup
 */

const globalBlobStorage = new Map<string, Map<string, File>>();

export const registerBlob = (
  fieldName: string,
  blobUrl: string,
  file: File
): void => {
  if (!globalBlobStorage.has(fieldName)) {
    globalBlobStorage.set(fieldName, new Map());
  }
  globalBlobStorage.get(fieldName)!.set(blobUrl, file);
};

export const getFileByBlobUrl = (
  fieldName: string,
  blobUrl: string
): File | undefined => {
  const blobMap = globalBlobStorage.get(fieldName);
  return blobMap?.get(blobUrl);
};

export const clearFieldBlobs = (fieldName: string): void => {
  const blobMap = globalBlobStorage.get(fieldName);
  if (blobMap) {
    blobMap.forEach((_, blobUrl) => {
      URL.revokeObjectURL(blobUrl);
    });
    globalBlobStorage.delete(fieldName);
  }
};
